import React from "react";
import userFollowers from "../../../assets/FollowersBlue.svg";
import androidImage from "../../../assets/android_icon_image.svg";
import { kFormatter } from "../../../redux/constants";
import { Rate, Tooltip } from "antd";
import PostAttachment from "../PostAttachment";
import QuotedPost from "../QuotedPost";

const CustomCardContent = ({
  el,
  data,
  custom_card_settings,
  PdfDownloadStatus,
  PptGeneratingStatus,
  isPreviewState,
  i,
  deepDive,
  isCommandCenterScreen,
  setAutoPlay,
}) => {
  // console.log(
  //   "CustomCardContent el  ==>",
  //   el,
  //   "settings ==>",
  //   custom_card_settings
  // );
  return (
    <>
      <div className="card-body p-0">
        {/* Followers and Android version and Rating */}
        {custom_card_settings?.card_body_placeholder_1?.length ? (
          <>
            {custom_card_settings?.card_body_placeholder_1?.map((d) => {
              return (
                <>
                  {/* Add Check For Followers */}
                  {!PdfDownloadStatus && el?.PlatformID === 1 && (
                    <div
                      className={`${
                        PdfDownloadStatus ? "mb-5" : "mb-15"
                      }  pl-15 d-flex pr-15 no--wrap`}
                    >
                      <img
                        src={userFollowers}
                        className="cardList__footer-label mr-1"
                        alt="userFollowers"
                      />
                      <span className="text-grayLight ml-1">Followers</span>
                      <Tooltip title={el?.Followers?.toLocaleString()}>
                        <span className="cardList__footer-count ml-1 blue-text font-weight800">
                          {kFormatter(el?.Followers)}
                        </span>
                      </Tooltip>
                    </div>
                  )}

                  {/* Add Android Version And Rating */}
                  {(el?.PlatformID === 7 || el?.PlatformID === 30) &&
                  el?.IsBrandPost === "User" ? (
                    <>
                      <div className="mb-2 pl-15 d-flex justify-content-between pr-15">
                        {el?.Rating >= 0 ? (
                          <span className="mr-15 d-flex align-items-center">
                            <Rate
                              disabled
                              value={el?.Rating ? el?.Rating : el?.rating}
                              className="no--wrap w-100 ratingList mr-1 "
                            />
                            {el?.Rating}
                          </span>
                        ) : (
                          ""
                        )}
                        {el?.PlatformID === 7 ? (
                          <span className="mr-15 d-flex align-items-center">
                            <span
                              className="w-100 text-ellipsis mr-1"
                              style={{ color: "blue" }}
                            >
                              App Version:
                            </span>
                            {el?.App_version === "NA" ? (
                              <>
                                <i
                                  className={`fa fa-minus cursor-pointer ml-1 fontSize-12 ${
                                    window.location.pathname
                                      .toLowerCase()
                                      ?.includes("/commandcenter/screens")
                                      ? "dynamic_icon_color"
                                      : "text-gray"
                                  }`}
                                />
                                <Tooltip
                                  title="Version information is not available for this review."
                                  placement="top"
                                  className="text-ellipsis d-inline-block wm-chart-card-title"
                                >
                                  <i
                                    className={`fa fa-info-circle cursor-pointer ml-1 ${
                                      window.location.pathname
                                        .toLowerCase()
                                        ?.includes("/commandcenter/screens")
                                        ? "dynamic_icon_color"
                                        : "text-gray"
                                    }`}
                                    style={{ overflow: "visible" }}
                                  />
                                </Tooltip>
                              </>
                            ) : (
                              el?.App_version
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                        {el?.PlatformID === 7 ? (
                          <span className="mr-15 d-flex align-items-center">
                            <img
                              src={androidImage}
                              alt="Android Image"
                              className="profileImg ml-1 mr-1"
                              style={{ width: "1.5rem" }}
                            />
                            {el?.Android_version}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      {el?.PlatformID === 7 ? (
                        <span className="ml-15 mb-5 d-flex align-items-center">
                          <span className="d-flex w-100">
                            <span
                              style={{ color: "blue" }}
                              className="text-ellipsis mr-1"
                            >
                              Device Name:
                            </span>
                            <span className="text-ellipsis">{el?.Device}</span>
                          </span>
                        </span>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            })}
          </>
        ) : (
          ""
        )}

        {/* Mention Text And Attachments */}
        {custom_card_settings?.card_body_placeholder_2?.length ||
        custom_card_settings?.card_body_placeholder_3?.length ? (
          <>
            <PostAttachment
              el={el}
              i={i}
              PdfDownloadStatus={PdfDownloadStatus}
              PptGeneratingStatus={PptGeneratingStatus}
              isCommandCenterScreen={isCommandCenterScreen}
              data={data}
              isPreviewState={isPreviewState}
              postText={el?.mention_text}
              deepDive={deepDive}
              custom_card_settings={custom_card_settings}
              setAutoPlay={setAutoPlay}
            />

            {el?.EmailContentHtml !== "NA" && el?.EmailContentHtml && (
              <QuotedPost
                el={el?.EmailContentHtml}
                i={i}
                PdfDownloadStatus={PdfDownloadStatus}
                PptGeneratingStatus={PptGeneratingStatus}
                isCommandCenterScreen={isCommandCenterScreen}
              />
            )}
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default CustomCardContent;
